/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { addOption } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import AddAnswer from 'material/embeds/content/edit/addanswer/addanswer';



/* ========== ~~~~~~~~~~ EMBED : EDIT : ADD : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId }) => ({
    numberOfOptions: Object.keys(embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options']).length,
});

const mapDispatchToProps = dispatch => ({
    addOption: contentId => dispatch(addOption(contentId))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddAnswer);
